module.exports = __webpack_public_path__ + "img/ILEK_120X35.1e1d665c.png";